var swiper = new Swiper(".block_compare-slider", {
    slidesPerView: 3.29,
    spaceBetween: 0,
   mousewheel: {
      forceToAxis: true,
    },
  scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      hide: false,
    },
   breakpoints: {  
         280: {
        slidesPerView:  1.15       
      },
       400: {
        slidesPerView:  2.15       
      },
      1440: {
        slidesPerView:  3.29
      }
    }
});

let comparebutton = document.querySelectorAll(".block_compare-product-button");
comparebutton.forEach((event) => {
  event.addEventListener('click', (tab) => {
    let target = tab.target;    
    target.classList.toggle("hidden");
    target.closest(".block_compare-products-info-width").querySelector(".block_compare-slider-main").classList.toggle("hidden");  
    target.closest(".block_compare-products-info-width").querySelector(".block_compare-product-header-arrow").classList.toggle("hidden");
    setTimeout(function(){
       for (let index = 0; index < 50 ; index++) {
        equl(`.block_compare-slider-main.active .block_compare-${index}`)
       }
      target.closest(".block_compare-products-info-width").querySelector(".block_compare-slider-main").classList.remove("active");        
       target.closest(".block_compare-products-info-width").querySelector(".block_compare-products-info-left").classList.add("active");
    }, 200)
  }) 
})

let  compareArrow = document.querySelectorAll(".block_compare-product-header-arrow");
compareArrow.forEach((event) => {
  event.addEventListener('click', (tab) => {
    let target = tab.target;    
    target.classList.toggle("hidden");
    target.closest(".block_compare-products-info-width").querySelector(".block_compare-slider-main").classList.toggle("hidden");
    target.closest(".block_compare-products-info-width").querySelector(".block_compare-product-button").classList.toggle("hidden");
    setTimeout(function(){
       for (let index = 0; index < 50 ; index++) {
        equl(`.block_compare-slider-main.active .block_compare-${index}`)
       } 
      target.closest(".block_compare-products-info-width").querySelector(".block_compare-products-info-left").classList.toggle("active");
    }, 200)
    
  }) 
})

// =============seemore=================





